export default from './share-link';



// WEBPACK FOOTER //
// ./app/components/share-link/index.js